import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Customize_Css/Pagination.css';
import { Dropdown,Modal,Button} from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaPlus, FaTrashAlt, FaFileExport, FaEdit, FaSearch, FaEye, FaUser } from 'react-icons/fa';
import '../Customize_Css/ViewVendor.css';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
import axios from 'axios'; 
import { ToastContainer, toast } from 'react-toastify';
import * as XLSX from 'xlsx';

const ViewIndependentDelivery = () => {
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const AuthorizationToken = localStorage.getItem('token');
    const epicxTenantId = localStorage.getItem('epicxTenantId');
    const navigate = useNavigate();
    const location = useLocation();
    const openedDeliveryRef = useRef(false);
    const [data, setData] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [selectedItems, setSelectedItems] = useState([]);
    const [originalData, setOriginalData] = useState([]); 
    const [selectedIndependentDelivery, setSelectedIndependentDelivery] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const formatDate = (dateString) => {
        const options = { day: '2-digit', month: 'long', year: 'numeric' };
        return new Date(dateString).toLocaleDateString('en-GB', options).replace(/ /g, '-');
    };
    
   useEffect(() => {
        const fetchData = async () => {
            if (!epicxTenantId) {
                toast.error('Tenant ID not found. Please log in again.');
                return;
            }

            try {
                const response = await axios.get(
                    `${BASE_URL}/independentDelivery/api/independentDelivery/${epicxTenantId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${AuthorizationToken}`,
                        },
                    }
                );

                const deliveries = response.data;
                setData(deliveries);
                setOriginalData(deliveries);
            } catch (error) {
                console.error('Error fetching independent deliveries:', error);
                if (error.response?.status === 400) {
                    toast.error('Tenant ID is required.');
                } else if (error.response?.status === 404) {
                    // toast.info('No active independent deliveries found.');
                    setData([]);
                    setOriginalData([]);
                } else {
                    // toast.error('Failed to load data. Please try again.');
                }
            }
        };

        fetchData();
    }, [BASE_URL, AuthorizationToken, epicxTenantId]);

    useEffect(() => {
        const openDeliveryId = location.state?.openDeliveryId;
        if (!openDeliveryId || openedDeliveryRef.current || data.length === 0) return;
        const person = data.find((item) => String(item._id) === String(openDeliveryId));
        if (person) {
            openedDeliveryRef.current = true;
            setSelectedIndependentDelivery(person);
            setShowModal(true);
        }
    }, [data, location.state]);
    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
        setData((prevData) => {
            return [...prevData].sort((a, b) => {
                if (a[key] < b[key]) {
                    return direction === 'asc' ? -1 : 1;
                }
                if (a[key] > b[key]) {
                    return direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
        });
    };

    const handleSearch = (value) => {
        setSearchTerm(value.toLowerCase());
        if (value.trim() === '') {
            setData(originalData); 
        } else {
            const filteredData = originalData.filter((item) =>
                Object.keys(item).some((key) =>
                    item[key].toString().toLowerCase().includes(value.toLowerCase()) 
                )
            );
            setData(filteredData); 
        }
        setCurrentPage(1); 
    };
    

    const handleSelectAll = () => {
        if (selectedItems.length === data.length) {
            setSelectedItems([]);
        } else {
            setSelectedItems(data.map(item => item._id));
        }
    };

    const handleSelectItem = (_id) => {
        if (selectedItems.includes(_id)) {
            setSelectedItems(selectedItems.filter(item => item !== _id));
        } else {
            setSelectedItems([...selectedItems, _id]);
        }
    };

    // Pagination 
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = data.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(data.length / itemsPerPage);

    const getDocumentNumber = (documents, docName) => {
        console.log("Documents array: ", documents);
        console.log("Searching for document name: ", docName);
        
        const doc = documents.find(document => {
            console.log("Checking document name: ", document.documentName);
            return document.documentName.toLowerCase() === docName.toLowerCase();
        });
    
        if (doc) {
            console.log("Found document: ", doc);
            return doc.documentNumber;
        } else {
            console.warn(`No document found for ${docName}`);
            return 'N/A';
        }
    };
    const handleDelete = async () => {
        if (selectedItems.length === 0) {
            toast.error('No items selected for deletion');
            return;
        }
        const confirmDelete = window.confirm('Are you sure you want to delete the selected items?');
        if (!confirmDelete) {
            toast.info('Deletion canceled');
            return;
        }

        try {
            const deleteRequests = selectedItems.map(id =>
                axios.put(`${BASE_URL}/independentDelivery/api/independentDelivery/delete/${epicxTenantId}/${id}`,
                    {}, 
                    {
                        headers: {
                            Authorization: `Bearer ${AuthorizationToken}`,
                          },
                        }
                )
            );
            await Promise.all(deleteRequests);
            const response = await axios.get(`${BASE_URL}/independentDelivery/api/independentDelivery/${epicxTenantId}`,
                {
                    headers: {
                        Authorization: `Bearer ${AuthorizationToken}`,
                      },
                    }
            );
            setData(response.data);
            setSelectedItems([]);
            toast.success('Independent Delivery Person Data deleted successfully');
        } catch (error) {
            console.error('Error deleting vendors:', error);
            toast.error('Error deleting items');
        }
    };
    const handleEdit = () => {
        if (selectedItems.length === 1) {
            const [selectedId] = selectedItems; 
            navigate(`/updateIndependentDelivery/${selectedId}`); 
        } else {
            toast.error("Please select exactly one Independent Delivery to edit");
        }
    };
    const handleExport = () => {
        const dataToExport = selectedItems.length > 0 
            ? data.filter(item => selectedItems.includes(item._id)) 
            : data;
        const exportData = dataToExport.map(item => ({
            fullName: item.fullName,
            emailAddress: item.emailAddress,
            degree: item.degree,
            bloodGroup: item.bloodGroup,
            dateOfBirth: item.dateOfBirth,
            country: item.country,
            state: item.state,
            city: item.city,
            primaryMobileNumber:item.primaryMobileNumber,
            whatsappNumber:item.whatsappNumber,
        }));
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Independent");
        XLSX.writeFile(wb, 'IndependentDelivery_data.xlsx');
    };
    const handleViewDetails = (independentDeliveryId) => {
        const independentDeliveryPerson = data.find((item) => item._id === independentDeliveryId);
        if (independentDeliveryPerson) {
            setSelectedIndependentDelivery(independentDeliveryPerson);
            setShowModal(true);
        }
    };
    const listColumns = [
        { key: 'deliveryAgent', label: 'Delivery Agent' },
        { key: 'aadharNumber', label: 'Aadhar Number' },
        { key: 'primaryMobileNumber', label: 'Primary Mobile Number' },
        { key: 'emailId', label: 'Email Id' },
        { key: 'address', label: 'Address' },
        { key: 'panNumber', label: 'Pan Number' },
    ];
    const person = selectedIndependentDelivery;

    return (
        <>
        <Sidebar/>
        <div className="vendors-page">
            <header className="vendors-hero">
                <div>
                    <p className="vendors-kicker">Vendors</p>
                    <h1>Independent Delivery Vendor List</h1>
                    <p>Browse, find, and manage independent delivery people for your store.</p>
                </div>
                <button
                    className="vendors-primary-btn"
                    onClick={() => navigate('/add-independent-delivery-person')}
                >
                    <FaPlus /> Add Independent Delivery Vendor
                </button>
            </header>

            <section className="vendors-toolbar" aria-label="Independent delivery search and actions">
                <div className="vendors-search">
                    <FaSearch aria-hidden="true" />
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search delivery people..."
                        aria-label="Search independent delivery vendors"
                        value={searchTerm}
                        onChange={(e) => handleSearch(e.target.value)}
                    />
                </div>
                <Dropdown>
                    <Dropdown.Toggle className="vendors-action-btn">
                        Action
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={handleDelete} disabled={selectedItems.length === 0}>
                            <FaTrashAlt className="me-2" /> Delete
                        </Dropdown.Item>
                        <Dropdown.Item onClick={handleExport}>
                            <FaFileExport className="me-2" /> Export
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </section>

            <div className="vendors-card">
                <div className="vendors-card-head">
                    <div>
                        <h2>All Independent Delivery Vendors</h2>
                        <p>Select a person to edit, delete, or view full details.</p>
                    </div>
                    <span className="vendors-count">
                        <FaUser aria-hidden="true" />
                        {data.length} {data.length === 1 ? 'person' : 'people'}
                    </span>
                </div>
                <div className="vendors-card-body">
                    <div className="vendors-table-wrap no-scroll">
                        <table className="vendors-table vendors-table-plain">
                            <thead>
                                <tr>
                                    <th className="vendors-check-cell">
                                        <input
                                            className="vendors-checkbox"
                                            type="checkbox"
                                            aria-label="Select all independent delivery vendors"
                                            checked={data.length > 0 && selectedItems.length === data.length}
                                            onChange={handleSelectAll}
                                        />
                                    </th>
                                    {listColumns.map((column) => (
                                        <th
                                            key={column.key}
                                            className={column.key === 'deliveryAgent' ? 'vendors-sticky-name' : undefined}
                                            onClick={() => handleSort(column.key)}
                                        >
                                            {column.label}
                                            {sortConfig.key === column.key ? (sortConfig.direction === 'asc' ? ' ▲' : ' ▼') : ''}
                                        </th>
                                    ))}
                                    <th className="vendors-action-cell">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentData.length > 0 ? currentData.map((item) => (
                                    <tr key={item._id} className={selectedItems.includes(item._id) ? 'is-selected' : ''}>
                                        <td className="vendors-check-cell">
                                            <input
                                                className="vendors-checkbox"
                                                type="checkbox"
                                                aria-label={`Select ${item.fullName}`}
                                                checked={selectedItems.includes(item._id)}
                                                onChange={() => handleSelectItem(item._id)}
                                            />
                                        </td>
                                        <td className="vendors-sticky-name"><span className="vendor-name">{item.fullName}</span></td>
                                        <td>{getDocumentNumber(item.documents, 'Aadhar Card')}</td>
                                        <td>{item.primaryMobileNumber}</td>
                                        <td>{item.emailAddress}</td>
                                        <td><span className="vendors-address-clamp" title={item.address}>{item.address}</span></td>
                                        <td><span className="vendor-gst">{getDocumentNumber(item.documents, 'PAN Card')}</span></td>
                                        <td className="vendors-action-cell">
                                            <div className="vendors-action-group">
                                                <button
                                                    type="button"
                                                    className="vendors-icon-btn vendors-icon-btn--view"
                                                    aria-label={`View details for ${item.fullName}`}
                                                    title="View details"
                                                    onClick={() => handleViewDetails(item._id)}
                                                >
                                                    <FaEye aria-hidden="true" />
                                                </button>
                                                <button
                                                    type="button"
                                                    className="vendors-icon-btn vendors-icon-btn--edit"
                                                    aria-label={`Edit ${item.fullName}`}
                                                    title="Edit delivery person"
                                                    onClick={() => navigate(`/updateIndependentDelivery/${item._id}`)}
                                                >
                                                    <FaEdit aria-hidden="true" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="8">
                                            <div className="vendors-empty">
                                                <span><FaUser aria-hidden="true" /></span>
                                                <h3>No delivery people found</h3>
                                                <p>Try another search or add a new independent delivery vendor.</p>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="vendors-card-footer">
                    <span className="vendors-page-summary">
                        {data.length > 0
                            ? `Showing ${indexOfFirstItem + 1}–${Math.min(indexOfLastItem, data.length)} of ${data.length}`
                            : 'Showing 0 people'}
                    </span>
                    <div className="vendors-pagination">
                        <nav>
                            <ul className="pagination mb-0" aria-label="Independent delivery pagination">
                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link btn-sm" onClick={() => setCurrentPage(1)} aria-label="First page">&laquo;</button>
                                </li>
                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link btn-sm" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} aria-label="Previous page">&lt;</button>
                                </li>
                                {Array.from({ length: totalPages }, (_, index) => (
                                    <li key={index + 1} className={`page-item ${index + 1 === currentPage ? 'active' : ''}`}>
                                        <button className="page-link btn-sm" onClick={() => setCurrentPage(index + 1)} aria-current={index + 1 === currentPage ? 'page' : undefined}>
                                            {index + 1}
                                        </button>
                                    </li>
                                ))}
                                <li className={`page-item ${currentPage === totalPages || totalPages === 0 ? 'disabled' : ''}`}>
                                    <button className="page-link btn-sm" onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} aria-label="Next page">&gt;</button>
                                </li>
                                <li className={`page-item ${currentPage === totalPages || totalPages === 0 ? 'disabled' : ''}`}>
                                    <button className="page-link btn-sm" onClick={() => setCurrentPage(totalPages || 1)} aria-label="Last page">&raquo;</button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>

        <Modal show={showModal} onHide={() => setShowModal(false)} size="xl" centered dialogClassName="vendor-details-modal">
            <Modal.Header closeButton>
                <Modal.Title>Independent Delivery Person Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {person ? (
                    <div className="vendor-details-content">
                        <div className="vendor-details-title">
                            {person.profileImage ? (
                                <img className="vendor-details-photo" src={person.profileImage} alt={person.fullName || 'Profile'} />
                            ) : (
                                <span><FaUser aria-hidden="true" /></span>
                            )}
                            <div>
                                <small>Independent delivery</small>
                                <h3>{person.fullName || 'N/A'}</h3>
                                <p>{person.degree || 'Degree not added'}</p>
                            </div>
                        </div>
                        <div className="vendor-details-grid">
                            <div><span>WhatsApp</span><strong>{person.whatsappNumber || 'N/A'}</strong></div>
                            <div><span>Country</span><strong>{person.country || 'N/A'}</strong></div>
                            <div><span>State</span><strong>{person.state || 'N/A'}</strong></div>
                            <div><span>City</span><strong>{person.city || 'N/A'}</strong></div>
                            <div><span>Date of Birth</span><strong>{formatDate(person.dateOfBirth) || 'N/A'}</strong></div>
                            <div className="details-wide"><span>Address</span><strong>{person.address || 'N/A'}</strong></div>
                        </div>

                        <section className="vendor-details-section">
                            <h4>Emergency Contact</h4>
                            <div className="vendor-details-grid">
                                <div><span>Name</span><strong>{person.nameOfEmergency || 'N/A'}</strong></div>
                                <div><span>Relationship</span><strong>{person.relationshipToAccountHolder || 'N/A'}</strong></div>
                                <div><span>Phone</span><strong>{person.emergencyPhoneNumber || 'N/A'}</strong></div>
                                <div className="details-wide"><span>Email</span><strong>{person.emergencyEmailAddress || 'N/A'}</strong></div>
                            </div>
                        </section>

                        <section className="vendor-details-section">
                            <h4>Documents</h4>
                            {person.documents && person.documents.length > 0 ? (
                                <div className="table-responsive">
                                    <table className="vendor-docs-table">
                                        <thead>
                                            <tr>
                                                <th>Document Name</th>
                                                <th>Document Number</th>
                                                <th>Document Type</th>
                                                <th>Expiry Date</th>
                                                <th>File</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {person.documents.map((doc, index) => (
                                                <tr key={index}>
                                                    <td>{doc.documentName || 'N/A'}</td>
                                                    <td>{doc.documentNumber || 'N/A'}</td>
                                                    <td>{doc.documentType || 'N/A'}</td>
                                                    <td>{formatDate(doc.documentExpiryDate) || 'N/A'}</td>
                                                    <td>
                                                        {doc.documentFile && (
                                                            <a href={doc.documentFile} target="_blank" rel="noopener noreferrer" className="vendors-view-btn">
                                                                <FaEye aria-hidden="true" /> View
                                                            </a>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <p className="vendor-details-empty">No documents available.</p>
                            )}
                        </section>

                        <section className="vendor-details-section">
                            <h4>Availability</h4>
                            <div className="vendor-details-grid">
                                <div className="details-wide">
                                    <span>Time Slots</span>
                                    <div className="vendor-detail-chips">
                                        {(person.timeAvailabilitySlot || []).length > 0
                                            ? person.timeAvailabilitySlot.map((slot, index) => <span key={index}>{slot}</span>)
                                            : <strong>N/A</strong>}
                                    </div>
                                </div>
                                <div className="details-wide">
                                    <span>Days Available</span>
                                    <div className="vendor-detail-chips">
                                        {(person.daySlot || []).length > 0
                                            ? person.daySlot.map((day, index) => <span key={index}>{day}</span>)
                                            : <strong>N/A</strong>}
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section className="vendor-details-section">
                            <h4>TAT Calculation</h4>
                            <div className="vendor-details-grid">
                                <div><span>Pickup Time</span><strong>{person.toPickupLocationTime || 'N/A'}</strong></div>
                                <div><span>Delivery Time</span><strong>{person.toDeliveryLocationTime || 'N/A'}</strong></div>
                                <div><span>Max Delivery Capacity</span><strong>{person.maximumDeliveryCapacity || 'N/A'}</strong></div>
                            </div>
                        </section>

                        <section className="vendor-details-section">
                            <h4>Bank Details</h4>
                            <div className="vendor-details-grid">
                                <div><span>Account Holder</span><strong>{person.accountHoldersName || 'N/A'}</strong></div>
                                <div><span>Type of Account</span><strong>{person.typeOfAccount || 'N/A'}</strong></div>
                                <div><span>Account Number</span><strong>{person.accountNumber || 'N/A'}</strong></div>
                                <div><span>IFSC Code</span><strong>{person.ifscCode || 'N/A'}</strong></div>
                                <div><span>Branch Name</span><strong>{person.branchName || 'N/A'}</strong></div>
                                <div><span>GPay Number</span><strong>{person.gpayNumber || 'N/A'}</strong></div>
                            </div>
                        </section>

                        <div className="vendor-details-grid">
                            <div><span>Created At</span><strong>{formatDate(person.createdAt) || 'N/A'}</strong></div>
                            <div><span>Updated At</span><strong>{formatDate(person.updatedAt) || 'N/A'}</strong></div>
                        </div>
                    </div>
                ) : (
                    <p className="vendor-details-empty">No vendor details available.</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button className="vendors-modal-close" onClick={() => setShowModal(false)}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
        <div className="vendors-footer">
            <Footer/>
        </div>
        <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={true}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            style={{ zIndex: 9999 }} 
        />
        </div>
        </>
    );
};

export default ViewIndependentDelivery;
